import React from "react";
import Slider from "@mui/material/Slider";
import { styled } from "@mui/material/styles";

const pinShape = `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 28 34'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M14 34L4.1005 24.0416C-1.36683 18.5418 -1.36683 9.62475 4.1005 4.12489C9.56784 -1.37496 18.4322 -1.37496 23.8995 4.12489C29.3668 9.62475 29.3668 18.5418 23.8995 24.0416L14 34Z' fill='%230C8092'/%3E%3C/svg%3E")`;

const TealSlider = styled(Slider)({
  color: "#0c8092",
  height: 6,
  padding: "20px 0",
  "& .MuiSlider-thumb": {
    width: 20,
    height: 20,
    backgroundColor: "#0c8092",
    border: "none",
    boxShadow: "0 0 0 8px rgba(12, 128, 146, 0.12)",
    "&:hover, &.Mui-focusVisible, &.Mui-active": {
      boxShadow: "0 0 0 8px rgba(12, 128, 146, 0.16)",
    },
  },
  "& .MuiSlider-rail": {
    color: "#d9d9d9",
    opacity: 1,
    height: 6,
  },
  "& .MuiSlider-track": {
    height: 6,
  },
  "& .MuiSlider-valueLabel": {
    backgroundColor: "transparent",
    backgroundImage: pinShape,
    backgroundRepeat: "no-repeat",
    backgroundSize: "100% 100%",
    borderRadius: 0,
    width: 28,
    height: 34,
    padding: 0,
    "&::before": {
      display: "none",
    },
    "& .MuiSlider-valueLabelLabel": {
      position: "absolute",
      top: 14,
      left: "50%",
      transform: "translate(-50%, -50%)",
      color: "#fff",
      fontSize: "12px",
      fontFamily: "Roboto",
      fontWeight: 500,
      letterSpacing: "0.5px",
    },
  },
});

export default function ComplianceSlider({ value, onChange }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 20, marginTop: 40 }}>
      <div style={{ flex: 1, height: 33, display: "flex", alignItems: "center" }}>
        <TealSlider
          value={value}
          onChange={(_, val) => onChange(val)}
          min={16}
          max={28}
          valueLabelDisplay="on"
          style={{ width: "100%" }}
        />
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 14,
            border: "1px solid #adadad",
            borderRadius: 6,
            height: 33,
            padding: "0 5px",
            background: "#fff",
          }}
        >
          <button
            onClick={() => onChange(Math.max(value - 1, 16))}
            style={{
              width: 20,
              height: 24,
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontFamily: "Poppins",
              fontSize: "16px",
              color: "#000",
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            −
          </button>
          <span
            style={{
              width: 20,
              textAlign: "center",
              fontFamily: "Poppins",
              fontSize: "16px",
              color: "#444",
            }}
          >
            {value}
          </span>
          <button
            onClick={() => onChange(Math.min(value + 1, 28))}
            style={{
              width: 20,
              height: 24,
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontFamily: "Poppins",
              fontSize: "16px",
              color: "#000",
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            +
          </button>
        </div>
        <span style={{ fontFamily: "Poppins", fontSize: "16px", color: "#444" }}>
          days
        </span>
      </div>
    </div>
  );
}
